"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// React
const react_1 = __importStar(require("react"));
// Models
const user_models_1 = require("../models/user.models");
// Services
const keycloak_service_1 = require("../services/keycloak.service");
const fetch_service_1 = require("../services/fetch.service");
// Context
const UserStateContext = react_1.createContext();
const getProviderValueProps = ({ status, keycloak, fetchWithCredentials }) => {
    return {
        authentication: {
            status,
            isAuthenticated: status === user_models_1.UserStatus.Authenticated,
            isPending: status === user_models_1.UserStatus.Pending,
            error: status === user_models_1.UserStatus.Error,
        },
        fetchWithCredentials,
        keycloak,
    };
};
/**
 * User authentication provider
 * @param children
 * @param keycloakConfig
 * @constructor
 */
exports.UserAuthenticationProvider = ({ children, keycloakConfig, keycloakInitOptions }) => {
    /**
     * Fetch request with authentication bearer
     * @param input
     * @param init
     */
    const authenticatedFetch = (input, init) => __awaiter(void 0, void 0, void 0, function* () {
        const fetchKInstance = yield keycloak_service_1.initKeycloak(keycloakConfig, keycloakInitOptions);
        try {
            const { fetchPromise, updatedKInstance } = yield fetch_service_1.fetchWithCredentials(fetchKInstance, input, init);
            if (updatedKInstance) {
                setState((s) => (Object.assign(Object.assign({}, s), { keycloak: updatedKInstance })));
            }
            return fetchPromise;
        }
        catch ({ fetchPromise }) {
            setState((s) => (Object.assign(Object.assign({}, s), { status: user_models_1.UserStatus.Unauthenticated, keycloak: null })));
            return fetchPromise;
        }
    });
    /** Initial state */
    const initialState = {
        status: user_models_1.UserStatus.Pending,
        keycloak: null,
        fetchWithCredentials: authenticatedFetch,
    };
    /** Authentication state */
    const [{ keycloak, status, fetchWithCredentials }, setState] = react_1.default.useState(initialState);
    const providerPropsValue = getProviderValueProps({ status, keycloak, fetchWithCredentials });
    /** Authentication effect */
    react_1.default.useEffect(() => {
        let ignore = false;
        const setAuthenticationStatus = (keycloak) => {
            !ignore && setState((s) => (Object.assign(Object.assign({}, s), { status: keycloak.authenticated ? user_models_1.UserStatus.Authenticated : user_models_1.UserStatus.Unauthenticated, keycloak })));
        };
        if (!keycloak) {
            keycloak_service_1.initKeycloak(keycloakConfig, keycloakInitOptions).then((instance) => {
                instance.onReady = () => {
                    setAuthenticationStatus(instance);
                };
                instance.onAuthError = (error) => {
                    console.error(error);
                    throw Error('Authentication error');
                };
                instance.onAuthRefreshSuccess = () => {
                    setAuthenticationStatus(instance);
                };
                instance.onAuthRefreshError = () => {
                    throw Error('Fail refresh token');
                };
            })
                .catch((error) => {
                console.error(error);
                return !ignore && setState((s) => (Object.assign(Object.assign({}, s), { status: user_models_1.UserStatus.Error, keycloak })));
            });
        }
        else if ([user_models_1.UserStatus.Pending, user_models_1.UserStatus.Error].includes(status)) {
            setAuthenticationStatus(keycloak);
        }
        return () => {
            ignore = true;
        };
    }, []);
    return (react_1.default.createElement(UserStateContext.Provider, { value: providerPropsValue }, children));
};
/** Hook context consumer */
exports.useUserAuthentication = () => react_1.useContext(UserStateContext);
exports.withUserAuthentication = (Component) => (props) => (react_1.default.createElement(UserStateContext.Consumer, null, (contextProps) => react_1.default.createElement(Component, Object.assign({}, props, contextProps))));
//# sourceMappingURL=state.provider.js.map